import gql from 'graphql-tag'

export const fetchRole = role_id => {
	return {
		query: gql`
			query ($role_id: bigint!) {
				rol: roles_by_pk(id: $role_id) {
					rol
					country_id
					is_administrator
					allow_hiring
					commercial_base: roles_commercial_bases {
						id: commercial_base_id
					}
				}
			}
		`,
		variables: { role_id }
	}
}
